// unit: filter3
import f from "../../../../funcs";
import Operator from "./Operator";


let Is = Operator.extend("Is", {
    literal: ["is"],

    validateValue(value) {
        if ( !f.isString(value) ) {
            return false;
        }

        value = value.toLowerCase().trim().replace(/\s+/g, " ");
        return (
            value === "null"
                || value === "not null"
                || value === "today"
                || value === "tomorrow"
        );
    },

    compile2js(left, right) {
        right = right.toLowerCase().trim().replace(/\s+/g, " ");

        if ( right === "null" ) {
            return left + " == null";
        }
        else if ( right === "not null" ) {
            return left + " != null";
        }
        else if ( right === "today" ) {
            return left + " >= " + f.todayStart() + " && " + left + " <= " + f.todayEnd();
        }
        else if ( right === "tomorrow" ) {
            return left + " >= " + f.tomorrowStart() + " && " + left + " <= " + f.tomorrowEnd();
        }
        else {
            throw new Error("imposible check: " + right);
        }
    }
});

export default Is;
